module.exports = __webpack_public_path__ + "img/MELA_Treg.df99c9b3.png";